import React, { useCallback, useState } from "react";
import ko from "knockout";
import { useStyles } from "./styles";
import ReportQueueControls from "./ReportQueueControls";

function toLocalDateTimeString(date, paramPath) {
  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");

  const paramName = paramPath?.toLowerCase();
  const millisecond = (paramName === "enddate" || paramName === "endingexitdate")
    ? "999"
    : String(date.getMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}`;
}

const ReportQueueControlsWrapper = ({ reportName, currentUser, reportQueueService, enqueueSnackbar, history }) => {
  const formatList = [
    { value: 0, label: 'PDF' },
    { value: 1, label: 'XLS' },
    { value: 2, label: 'XLSX' },
    { value: 3, label: 'RTF' },
    { value: 4, label: 'DOCX' },
    { value: 5, label: 'MHT' },
    { value: 6, label: 'HTML' },
    { value: 7, label: 'Text' },
    { value: 8, label: 'CSV' },
    { value: 9, label: 'Image' },
  ];

  const localDateParamNames = new Set([
  "startdate",
  "enddate",
  "startingexitdate",
  "endingexitdate",
  ]);

  const [exportFormat, setExportFormat] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const classes = useStyles();

  const handleSubmitToQueue = useCallback(async () => {
    setIsSubmitting(true);
    try {
      const rawModel = ko.dataFor(document.querySelector(".viewport"));
      const symbols = Object.getOwnPropertySymbols(rawModel.viewerModel);
      const latestValueSymbol = symbols.find((s) => s.toString() === "Symbol(_latestValue)");
      const previewModel = rawModel.viewerModel[latestValueSymbol];
      const parametersModel = previewModel?.parametersModel;

      if (parametersModel) {
        const submittedParams = {};
        const parameterList = parametersModel._parameters;

        parameterList.forEach((param) => {
          if (typeof param.value === "function") {
            const paramValue = param.isMultiValue && typeof param._value === "function"
              ? param._value()
              : param.value();

            submittedParams[param.path] = localDateParamNames.has(param.path?.toLowerCase())
              ? toLocalDateTimeString(paramValue, param.path)
              : paramValue;
          } else {
            submittedParams[param.path] = param.value;
          }
        });

        const jobRequest = {
          reportName,
          requestedBy: currentUser.UserID,
          parameters: submittedParams,
          exporttype: formatList[exportFormat].label,
        };

        const result = await reportQueueService.addReportJob(jobRequest);
        if (result.status === 200) {
          enqueueSnackbar("Report job submitted successfully", {
            variant: "success",
            tag: "JobSubmissionSuccess",
          });
          setTimeout(() => {
            history.push("/reportqueue");
          }, 1000);
        }else {
          console.error("Job submission failed with non-200 status", result);
          enqueueSnackbar("Failed to submit a report job", {
            variant: "error",
            tag: "JobSubmissionFailed",
          });
          setIsSubmitting(false);
        }
      }
    } catch (error) {
      console.error("Job submission failed", error);
      enqueueSnackbar("Failed to submit a report job", {
        variant: "error",
        tag: "JobSubmissionFailed",
      });
      setIsSubmitting(false);
    }
  }, [exportFormat, reportName, currentUser, reportQueueService, enqueueSnackbar, history]);

  return (
    <ReportQueueControls
      exportFormat={exportFormat}
      setExportFormat={setExportFormat}
      formatList={formatList}
      onSubmit={handleSubmitToQueue}
      classes={classes}
      disabled={isSubmitting}
    />
  );
};

export default ReportQueueControlsWrapper;
